import { array } from "valibot"

import { BaseApiService, KyOptions } from "@finq/app-base/composables/services/api.service"

import {
  PensionRecommendationSchema,
  ReCalculateRecommendation,
} from "../../types/pension-recommendations-services"
import { PensionCategoriesEnum } from "../../types/portfolio"

export class PensionRecommendationsServiceRaw extends BaseApiService {
  getRecommendations = (config: KyOptions<{ category?: PensionCategoriesEnum }> = {}) => {
    return this.instance
      .get(`/pensions/portfolio/recommendations`, config)
      .then(this.getData)
      .then((data) => this.parse(data, array(PensionRecommendationSchema)))
  }

  reCalculateRecommendation = (recId: string, data: ReCalculateRecommendation, config: KyOptions = {}) => {
    return this.instance
      .put(`/pensions/portfolio/recommendations/${recId}/recalculate`, data, config)
      .then(this.getData)
      .then((data) => this.parse(data, PensionRecommendationSchema))
  }

  postRecommendations = async (config?: KyOptions) => {
    return this.instance.post(
      `/pensions/portfolio/recommendations`,
      {},
      { ...config, timeout: 2 * 60 * 1000 }
    )
  }

  selectRecommendation = (data: { selections: Record<string, boolean> }, config: KyOptions = {}) => {
    return this.instance.post(`/pensions/portfolio/recommendations/select`, data, {
      ...config,
      timeout: 2 * 60 * 1000,
    })
  }
}

export const PensionRecommendationsService = new PensionRecommendationsServiceRaw()
